<template>
  <header class="h-fit w-full rounded-lg bg-branding-background p-4" data-cy="platformHeaderMobile">
    <div class="flex items-center justify-between space-x-2">
      <div class="flex min-w-0 items-center space-x-2 text-sm">
        <platform-branding-logo class="shrink-0" />
        <template v-if="showStageDetails">
          <div v-if="stageProgressAsString" class="shrink-0">
            {{ stageProgressAsString }}
          </div>
          <div
            v-if="currentStage?.stage_name"
            class="break-long-words min-w-0 text-sm font-semibold text-white"
          >
            {{ currentStage.stage_name }}
          </div>
          <icon-info-outline
            v-if="currentStage?.stage_description"
            v-tooltip="{ content: currentStage.stage_description, placement: 'bottom' }"
            class="shrink-0 cursor-pointer"
            data-cy="icon-info"
          />
        </template>
      </div>
      <button class="shrink-0" @click="emit('hamburger:click')">
        <icon-hamburger-menu class="text-white" />
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import useApplicationsState from "@/composables/state/applicationsState";

import IconInfoOutline from "@/components/icons/IconInfoOutline.vue";
import IconHamburgerMenu from "@/components/icons/IconHamburgerMenu.vue";
import PlatformBrandingLogo from "@/components/platform/PlatformBrandingLogo.vue";

const { showStageDetails = true } = defineProps<{
  showStageDetails?: boolean;
}>();

const emit = defineEmits<{
  "hamburger:click": [];
}>();

const { t } = useI18n();
const { applicationStages, currentStage } = useApplicationsState();

const stageProgressAsString = computed(() => {
  const indexOfCurrentStage = applicationStages.value.findIndex((stage) => stage.is_current);

  if (indexOfCurrentStage === -1) {
    return "";
  }

  const numberOfStages = applicationStages.value.length;
  const currentStageAsNumber = indexOfCurrentStage + 1;

  return `${t("common.stage")} ${currentStageAsNumber}/${numberOfStages}`;
});
</script>

<style scoped>
@reference "@/tailwind.css";

.break-long-words {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  white-space: pre-wrap;
}
</style>
